import { useMutation, useQueryClient } from "@tanstack/react-query";
import { buildUrl, toastServerError } from "helpers";
import { ApiError, ApiServiceError, instance } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { AiAssistant } from "../../aiAgents.types";
import {
  AI_ASSISTANTS_QUERY_KEY,
  ApiRoutesAiAssistants
} from "../../constants/enums";

interface UpdateAssistantBody {
  assistantId: string;
  name?: string;
  isActive?: boolean;
}

const requestUpdateAssistant = async ({
  assistantId,
  ...body
}: UpdateAssistantBody): Promise<AiAssistant> =>
  await instance.patch(
    buildUrl(ApiRoutesAiAssistants.Assistants, assistantId),
    body
  );

export const useUpdateAssistant = (
  options?: MutationOptions<
    AiAssistant,
    ApiServiceError<ApiError>,
    UpdateAssistantBody
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: requestUpdateAssistant,
    onError: toastServerError,
    ...options,
    onSuccess: (data, vars, ctx) => {
      queryClient.invalidateQueries({
        queryKey: [AI_ASSISTANTS_QUERY_KEY, "list"]
      });
      options?.onSuccess?.(data, vars, ctx);
    }
  });
};
